import { IdentityUserAri } from '@atlassian/ari';
import type { PreloadedQuery } from 'react-relay';
import type { RouteResource } from 'react-resource-router';

import { AggListQuery, type AggListQueryType } from '@townsquare/agg-list/query';
import { createRelayResource } from '@townsquare/relay-utils';
import { AggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { HomeResourceContext } from '@townsquare/router/types';
import { isGateEnabled } from '@townsquare/stat-sig/gate';

const EDGES_AND_TYPES: { edge: string }[] = [
	{ edge: 'user_favorited_confluence_page' },
	{ edge: 'user_favorited_confluence_blogpost' },
	{ edge: 'user_favorited_confluence_whiteboard' },
	{ edge: 'user_favorited_confluence_database' },
	{ edge: 'user_favorited_townsquare_project' },
];

const ALL_EDGES = EDGES_AND_TYPES.map(({ edge }) => edge).join('|');

const createCypherQuery = (accountId: string) => {
	const userAri = IdentityUserAri.create({ userId: accountId }).toString();

	return `MATCH (user: IdentityUser {ari: '${userAri}'})-[rel:${ALL_EDGES}]->(entity) RETURN entity ORDER BY rel.createdAt DESC`;
};

export const starredFeedResource: RouteResource<PreloadedQuery<AggListQueryType>> =
	createRelayResource<AggListQueryType>({
		getQuery: (_, resourceContext) => {
			const context = resourceContext as HomeResourceContext;
			const accountId = context.user.accountId;

			const cypherQuery = createCypherQuery(accountId);

			return {
				environment: AggRelayEnvironment,
				query: AggListQuery,
				variables: {
					cypherQuery,
					queryContext: `ari:cloud:platform::org/${context?.orgId}`,
					isEnabled: !!context?.orgId,
					first: isGateEnabled('townsquare_starred_workarounds') ? 250 : 100,
				},
			};
		},
	});
